/**
 * Lesson Store — tracks current lesson state for student mode.
 * Follows the same Zustand vanilla pattern as zoneStore, projectStore, etc.
 */
import { createStore } from 'zustand/vanilla';
import { LessonFlowState } from '@graphicsim/shared-types';

export interface LessonStoreState {
  currentLessonId: string | null;
  flowState: LessonFlowState;
  score: number;
  maxScore: number;
  startedAt: number | null;

  // Actions
  startLesson: (id: string, maxScore: number) => void;
  setFlowState: (state: LessonFlowState) => void;
  addScore: (points: number) => void;
  endLesson: () => void;
  reset: () => void;
}

export const lessonStore = createStore<LessonStoreState>((set) => ({
  currentLessonId: null,
  flowState: LessonFlowState.SELECT,
  score: 0,
  maxScore: 0,
  startedAt: null,

  startLesson: (id, maxScore) => {
    set({
      currentLessonId: id,
      flowState: LessonFlowState.SIMULATION,
      score: 0,
      maxScore,
      startedAt: Date.now(),
    });
  },

  setFlowState: (flowState) => {
    set({ flowState });
  },

  addScore: (points) => {
    set((s) => ({ score: s.score + points }));
  },

  endLesson: () => {
    set({ flowState: LessonFlowState.RESULTS });
  },

  reset: () => {
    set({
      currentLessonId: null,
      flowState: LessonFlowState.SELECT,
      score: 0,
      maxScore: 0,
      startedAt: null,
    });
  },
}));
